/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import './index.css';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Step from '../step';
import Finish from './finish';
import scrollToTop from '../../utils/scrollToTop';
import {setisLoading} from '../../actions/app';

class Step3 extends Component {
  constructor(props) {
    super(props);
    scrollToTop();
    this.props.setisLoading(false);
  }

  render (){
    return (
      <Step step={3}>
        <Finish />
        <div className="mcycle-step-tips-title">回收前注意事项</div>
      </Step>
    )
  }
}

export default connect(
  state => ({}),
  {setisLoading}
)(Step3);



// WEBPACK FOOTER //
// ./src/components/step3/index.js